/**
 * Created by user on 2020/6/6.
 */

export * from './lib';
import { removeZeroWidth } from './lib';

export default removeZeroWidth
